import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Users, MapPin, Database, LogOut, Plus, Target, UserCog, Map, Banknote } from "lucide-react";

const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/youth", label: "Registrations", icon: Users },
  { to: "/progress", label: "Progress", icon: Target },
  { to: "/heatmap", label: "Heatmap", icon: Map },
  { to: "/bank", label: "Bank Linkage", icon: Banknote },
  { to: "/villages", label: "Villages", icon: MapPin },
  { to: "/officers", label: "Officers", icon: UserCog, adminOnly: true },
  { to: "/data-tools", label: "Import / Export", icon: Database },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-paper flex">
      {/* Sidebar */}
      <aside className="w-64 bg-[#1E3A8A] text-white flex flex-col" data-testid="sidebar">
        <div className="p-6 border-b border-white/10">
          <Link to="/dashboard" className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-white text-[#1E3A8A] flex items-center justify-center font-heading font-bold">PS</div>
            <div>
              <div className="font-heading font-bold tracking-tight">padaskillinfo</div>
              <div className="text-[10px] uppercase tracking-widest text-white/60">Admin Console</div>
            </div>
          </Link>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.filter((n) => !n.adminOnly || user?.role === "admin").map((n) => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                    isActive ? "bg-white text-[#1E3A8A]" : "text-white/85 hover:bg-white/10"
                  }`
                }
                data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-").replace(/\//g, "-")}`}
              >
                <Icon className="w-4 h-4" /> {n.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="p-4 border-t border-white/10">
          <Link to="/register" target="_blank">
            <Button className="w-full bg-[#F59E0B] hover:bg-[#F59E0B]/90 mb-3" data-testid="open-register-form">
              <Plus className="w-4 h-4 mr-2" /> New Registration
            </Button>
          </Link>
          <div className="flex items-center gap-3 mb-3">
            <div className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center text-sm font-bold">
              {(user?.name || "?")[0].toUpperCase()}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium truncate">{user?.name}</div>
              <div className="text-xs text-white/60 truncate">{user?.role}</div>
            </div>
          </div>
          <Button onClick={handleLogout} variant="outline" className="w-full bg-transparent border-white/20 text-white hover:bg-white/10" data-testid="logout-btn">
            <LogOut className="w-4 h-4 mr-2" /> Logout
          </Button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
